
/** Globally useful constants or pseudo-constants
 */
export class Constants {
    static readonly APP_TITLE = 'RapidRona';
    static readonly DEFAULT_DEBOUNCE_DELAY = 100;
    static readonly ERR_REQUIRED = 'Required';
    static readonly ERR_INVALID_ZIP = 'A 5-digit US ZIP code is required';
    static readonly ERR_INVALID_EMAIL = 'Must be a valid email address';
    static readonly ERR_EMAIL_TAKEN = "Email is already in use by a registered user";
    static readonly ERR_INVALID_PHONE = "Must be a valid US phone number";
    static readonly ERR_INVALID_DATE = "Must be a valid date in format mm/dd/yyyy";
    static readonly ERR_UNDERAGE = "You must be 18 to access healthcare without a parent";
    static readonly ERR_PASSWORD_MISMATCH = "The passwords don't match";
    static readonly MIN_PASSWORD_LENGTH = 8;
    static readonly ERR_PASSWORD_LENGTH = `The password must have at least ${Constants.MIN_PASSWORD_LENGTH} characters`;
    static readonly ERR_PASSWORD_LETTERS_DIGITS = "The password must contain letters and digits";
    static readonly ERR_PASSWORD_SPACES = "The password can't contain spaces";
    static readonly US_PHONE_REGEX = /^\s*[(]?\d{3}[)]?[-\s\.]?\d{3}[-\s\.]?\d{4}\s*$/;
    static readonly US_ZIP_REGEX = /^\s*\d{5}\s*$/;
    static readonly EMAIl_REGEX =
     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    static readonly EMAIL_RELAXED_REGEX =
     /^\s*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+\s*$/;
    static readonly US_DATE_REGEX = /^\d{1,2}\/\d{1,2}\/\d{4}$/;

    static readonly MSG_PASSWORD_UPDATED = "Password updated successfully";

    static readonly DEFAULT_PAGE_SIZE = 10;
}
